import { TableColumnsSetting } from '@/interfaces/table-setting';
import { CustomerModel } from '@/models/tables/customer.model';

export class CustomersTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof CustomerModel> {
    return [
      {
        name: 'numeroBp',
        text: 'Numero BP',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'codiceFiscale',
        text: 'Codice Fiscale',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'piva',
        text: 'P.IVA',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazione',
        text: 'Cognome/Ragione Sociale',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataNascita',
        text: 'Data di nascita',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'luogoNascita',
        text: 'Luogo di nascita',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'localita',
        text: 'Località',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'indirizzo',
        text: 'Indirizzo',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numeroTelefono',
        text: 'Telefono',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'email',
        text: 'Email',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numeroPatente',
        text: 'Nr. Patente',
        filter: {
          type: 'input',
        },
      },
    ];
  }
}
